import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { TimezoneProvider } from "./contexts/TimezoneContext";
import { BrowserRouter } from "react-router-dom";
import './shared/styles/designSystem.css';
import './index.css';

const rootElement = document.getElementById("root");

const app = (
  <BrowserRouter>
    <TimezoneProvider>
      <App />
    </TimezoneProvider>
  </BrowserRouter>
);

// The prerendered markup is a snapshot of the client DOM, not React server
// output, so it cannot be hydrated. App reuses it as the first route's
// Suspense fallback and createRoot replaces it in place.
ReactDOM.createRoot(rootElement).render(app);
